import mouseStoker from './common/modules/mouseStorker'

import featureSec from './athletes/top/featureSec'
import pickUpSec from './athletes/top/pickupSec'

(() => {
  featureSec();
  pickUpSec();
})();

window.addEventListener('load', function() {
  document.body.classList.add('is-loaded');
  mouseStoker();
});
